import React, { useEffect, useState } from "react";
import "../App.scss";
import { Button, Card, Col, Flex, Input, message, Popover, Row, Space, Spin, Typography } from "antd";
import { CopyOutlined, InboxOutlined, MailOutlined, QuestionCircleOutlined, WhatsAppOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import AxiosService from "../services/APIService";
import { useLocation, useNavigate } from "react-router-dom";
import { LocalStorageService } from "../services/LocalStorage";
import { PRODUCT } from "../const";
import comboQR from "../Assets/PIPGRID - COMBO-QR.jpg";
import MasterQR from "../Assets/PIPGRID - MASTER-QR.jpg";
import PowerQR from "../Assets/PIPGRID - POWER-QR.jpg";
import FortuneQR from "../Assets/PIPGRID - FORTUNE-QR.jpg";
import { handleEmailClick, handleWhatsAppClick } from "../commonFunction";
import whatsappimg from "../Assets/whatsapp_PNG95162-300x252.webp";
import UPIQR from "../Assets/UPIQR.jpg";
import gpay from "../Assets/gpay.png";
import phonePay from "../Assets/phonepay.png";
import amzonPay from "../Assets/amzonpay.png";
import bhimPay from "../Assets/bhim.png";
import TRC from "../Assets/TRC.png";
import ComboUPI from "../Assets/comboUPI.jpg";
import ProductUPI from "../Assets/ProductUPI.jpg";

const PaymentQr = () => {
  const apiService = new AxiosService();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [transactionNumber, setTransactionNumber] = useState("");
  const user = LocalStorageService.getItem("user");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const productName = searchParams.get("productName")?.trim().toLowerCase();
    const paymentMethod = searchParams.get("paymentMethod")?.trim().toUpperCase();

    if (productName) {
      const matchedProduct = PRODUCT?.find((p) => p.productName.toLowerCase() === productName);

      if (matchedProduct) {
        setSelectedProduct(matchedProduct);
      } else {
        console.warn("No matching product found.");
      }
    } else {
      console.warn("productName param missing in URL.");
    }

    if (paymentMethod) {
      setSelectedPaymentMethod(paymentMethod);
    } else {
      console.warn("paymentMethod param missing in URL.");
    }
  }, [location.search]);

  const handleChange = ({ fileList }) => {
    setFileList(fileList.slice(-1));
  };

  const handleTransactionNumberChange = (e) => {
    setTransactionNumber(e.target.value);
  };

  const handleSubmit = async () => {
    if (selectedPaymentMethod === "USDT" && !transactionNumber) {
      message.error("Transaction number is required");
      return;
    }

    if (fileList.length === 0) {
      message.error("Please upload proof of payment");
      return;
    }

    const formData = new FormData();
    formData.append("transactionNumber", transactionNumber);

    fileList.forEach((file, index) => {
      formData.append(`file_${index + 1}`, file.originFileObj);
    });

    setLoading(true);
    try {
      const response = await apiService.put(`/auth/transaction-info/${user?._id}`, formData);

      if (response) {
        message.success("Transaction data updated successfully");
        navigate("/thank-you");
      } else {
        message.error("Failed to update transaction data");
      }
    } catch (error) {
      console.error("Transaction update error:", error);
      message.error(error?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const getText = () => {
    const name = selectedProduct?.productName;
    if (name === "PG Gold") return "TAExLDooPNbuy8XBrxrtD1uU9UrU72vVuQ";
    if (name === "PG Silver") return "TPWKXDViyA5DhJWqjCj3bTGLAnEKgusCaC";
    if (name === "PG Platinum") return "TH4k5Fnt51YToa3CnckMWYCW4KUyV7GfUb";
    return "TKYf1u2b2FEGmPDUF9jUdWLKzG6pDjc2XX";
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(getText())
      .then(() => {
        console.log("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy!", err);
      });
  };
  return (
    <Spin spinning={loading} size="large">
      <div className="register-wrapper" style={{ padding: "40px 0", color: "black" }}>
        <div className="form-parent">
          <Row gutter={[20, 20]} style={{ display: "flex", flexWrap: "wrap" }}>
            <Col xs={24} sm={24} md={24} lg={10} xl={10} className="title" style={{ display: "flex" }}>
              <Card
                style={{
                  paddingTop: "20px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Typography
                    style={{
                      textAlign: "center",
                      paddingBottom: "20px",
                      fontSize: "16px",
                      fontWeight: "500",
                      color: " #FAF8B1",
                    }}
                  >
                    {selectedPaymentMethod === "UPI" ? "UPI" : "USDT Details"}
                  </Typography>
                  <img
                    src={
                      selectedPaymentMethod === "UPI"
                        ? selectedProduct?.productName === "Combo"
                          ? ComboUPI
                          : ProductUPI
                        : selectedProduct?.productName === "PG Gold"
                        ? MasterQR
                        : selectedProduct?.productName === "PG Platinum"
                        ? FortuneQR
                        : selectedProduct?.productName === "PG Silver"
                        ? PowerQR
                        : comboQR
                    }
                    style={{ width: selectedPaymentMethod === "UPI" ? "75%" : "50%" }}
                    alt="QR Code"
                  />

                  {selectedPaymentMethod !== "UPI" && (
                    <Flex justify="center" align="center" gap={10} style={{ padding: "20px 0" }}>
                      <Typography style={{ fontSize: "14px", color: "#fff" }}>{getText()}</Typography>
                      <CopyOutlined style={{ fontSize: "14px", color: "#fff" }} onClick={handleCopy} />
                    </Flex>
                  )}

                  {selectedPaymentMethod === "UPI" ? (
                    <Typography style={{ fontSize: "18px", color: "#fff", marginTop: 10 }}>
                      {selectedProduct?.productName === "Combo" ? "Pay 50,900/-" : "Pay 33,900/-"}
                    </Typography>
                  ) : (
                    <Typography style={{ fontSize: "18px", color: "#fff" }}>
                      {selectedProduct?.productName === "Combo" ? "Pay $599" : "Pay $666"}
                    </Typography>
                  )}
                  {selectedPaymentMethod === "UPI" ? (
                    <Flex gap={20} style={{ marginTop: 20 }} justify="center">
                      <img src={gpay} style={{ width: "44px", height: "40px" }} />
                      <img src={phonePay} style={{ width: "40px", height: "40px" }} />
                      <img src={amzonPay} style={{ width: "45px", height: "45px" }} />
                      <img src={bhimPay} style={{ width: "40px", height: "40px" }} />
                    </Flex>
                  ) : (
                    <div style={{ marginTop: 10 }}>
                      <img src={TRC} style={{ width: "60px", height: "60px" }} />
                    </div>
                  )}
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={24} md={24} lg={14} xi={14} className="title" style={{ display: "flex" }}>
              <Card
                style={{
                  paddingTop: "24px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <Typography
                    style={{
                      textAlign: "center",
                      paddingBottom: "20px",
                      fontSize: "16px",
                      fontWeight: "500",
                      color: " #FAF8B1",
                    }}
                  >
                    Instructions
                  </Typography>
                  {selectedPaymentMethod === "USDT" ? (
                    <ul className="uiTitle">
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Scan the QR Code:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          Open your crypto wallet app and scan the QR code displayed on the payment page.
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Verify the Payment Amount:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          {" "}
                          Double-check that the amount shown in your wallet matches the required payment on the portal.
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Complete the Transaction:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          If everything is correct, authorize and finalize the payment within your wallet.
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Save Proof of Payment:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          {" "}
                          Once the transaction is successful, take a clear screenshot or photo of the confirmation.
                          (Ensure the image clearly shows the payment amount and transaction ID.)
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Submit for Verification:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          Upload the screenshot and submit your payment for approval.
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Await Confirmation:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          {" "}
                          You may leave the page after submitting your request. (We will review your payment and notify
                          you once it's verified.)
                        </Typography.Text>
                      </div>
                    </ul>
                  ) : (
                    <ul
                      style={{
                        textAlign: "left",
                        padding: "0 0px 0 20px",
                        fontSize: "16px",
                        color: "#fff",
                        margin: "0",
                      }}
                    >
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Open Your UPI App:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          Launch your preferred UPI app (PhonePe, Google Pay, Paytm, etc.).
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Scan the UPI QR Code:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          Use the in-app scanner to scan the UPI QR code displayed on the payment page.
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Verify the Payment Amount:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          Ensure that the amount auto-filled in your app matches the required amount shown on the
                          portal.
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Complete the Payment:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          If everything looks good, confirm and authorize the payment using your UPI PIN.
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Save Proof of Payment:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          Once the transaction is complete, take a clear screenshot of the payment confirmation. (Make
                          sure it clearly shows the amount paid, UPI transaction ID, and time.)
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong>Submit for Verification:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          Upload the screenshot on the portal and click "Submit" to send it for review.
                        </Typography.Text>
                      </div>
                      <div style={{ paddingBottom: "10px" }}>
                        <li>
                          <strong> Await Confirmation:</strong>
                        </li>
                        <Typography.Text className="uiText">
                          You can now leave the page. Our team will verify your payment and notify you once it's
                          approved.
                        </Typography.Text>
                      </div>
                    </ul>
                  )}
                </div>
              </Card>
            </Col>

            <Typography style={{ fontSize: "16px", color: "#fff", paddingLeft: "10px" }}>Transaction Proof</Typography>
            <Col span={24}>
              <Row gutter={[20, 20]}>
                <Col span={selectedPaymentMethod === "USDT" ? 12 : 24}>
                  <Dragger
                    style={{ width: "100%", backgroundColor: "#131C2B" }}
                    fileList={fileList}
                    onChange={handleChange}
                    beforeUpload={() => false}
                    showUploadList={false}
                    maxCount={1}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined style={{ color: "#FEF250" }} />
                    </p>
                    <p className="ant-upload-text" style={{ color: "#fff" }}>
                      Click or drag file to this area to upload
                    </p>
                  </Dragger>
                </Col>

                {/* Show Transaction # input ONLY if payment method is USDT */}
                {selectedPaymentMethod === "USDT" && (
                  <Col span={12}>
                    <Typography style={{ fontSize: "16px", paddingBottom: "12px", color: "#fff" }}>
                      Enter your Transaction #
                    </Typography>
                    <Input
                      placeholder="Transaction Number"
                      value={transactionNumber}
                      onChange={handleTransactionNumberChange}
                    />
                    <div style={{ marginTop: "20px" }}>
                      <Button
                        type="primary"
                        onClick={handleSubmit}
                        style={{ backgroundColor: "#FEF250", lineHeight: 1 }}
                      >
                        Submit
                      </Button>
                    </div>
                  </Col>
                )}
              </Row>

              {fileList?.length > 0 && (
                <div style={{ marginTop: "14px", padding: "10px", border: "1px solid #d9d9d9", borderRadius: "5px" }}>
                  <Typography style={{ fontSize: "14px", fontWeight: "500", color: "#fff", paddingBottom: "2px" }}>
                    Uploaded Files:
                  </Typography>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0, color: "#fff" }}>
                    {fileList.map((file, index) => (
                      <li key={file.uid} style={{ fontSize: "12px" }}>
                        {index + 1}. {file.name}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div style={{ marginTop: "25px" }}>
                {selectedPaymentMethod === "UPI" && (
                  <Button type="primary" onClick={handleSubmit} style={{ backgroundColor: "#FEF250", lineHeight: 1 }}>
                    Submit
                  </Button>
                )}
              </div>
            </Col>

            <Col span={24}>
              <Typography style={{ fontSize: "16px", color: "#fff", fontWeight: 300 }}>
                For Support, Contact us at
              </Typography>
              <Flex align="center" gap={20}>
                <Space align="center">
                  <WhatsAppOutlined style={{ fontSize: "16px", color: "#FEF250" }} />
                  <Typography style={{ color: "white", fontSize: "16px" }} onClick={handleWhatsAppClick}>
                    +971 0525218176
                  </Typography>
                </Space>
                <Space align="center">
                  <MailOutlined style={{ fontSize: "16px", color: "#FEF250" }} />
                  <Typography style={{ color: "white", fontSize: "16px" }} onClick={handleEmailClick}>
                    support@pipgrid.com
                  </Typography>
                </Space>
              </Flex>
            </Col>
          </Row>
        </div>
        <div className="whatsapp">
          <img src={whatsappimg} style={{ cursor: "pointer" }} onClick={handleWhatsAppClick} />
        </div>
      </div>
    </Spin>
  );
};

export default PaymentQr;
